import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=c703ad50&scoped=true&"
var script = {}
import style0 from "./Terms.vue?vue&type=style&index=0&id=c703ad50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c703ad50",
  null
  
)

export default component.exports